module.exports = { "default": require("core-js/library/fn/regexp/escape"), __esModule: true };


//////////////////
// WEBPACK FOOTER
// ./~/babel-runtime/core-js/regexp/escape.js
// module id = 93
// module chunks = 0